import z from 'zod';
export const PURCHASE_LINE_TARGET_ERROR = 'Choisissez une prestation et son tarif, ou saisissez un libellé';
export const PURCHASE_LINE_PRICE_REQUIRED_ERROR = 'Le prix unitaire est requis sur une ligne libre';
// Shared by order lines and invoice lines. A line is either a prestation line (prestation + tarif,
// which moves stock) or a free line (a label, no stock). Kept as a raw shape plus a refinement so
// each schema can add its own fields: a refined Zod object can no longer be extended.
export const purchaseLineShape = {
    accountingCategoryIds: z
        .array(z.number().int())
        .max(1, 'Une seule catégorie comptable est autorisée')
        .default([]),
    prestationId: z.number().int().positive().nullable().default(null),
    prestationPriceId: z.number().int().positive().nullable().default(null),
    label: z
        .string()
        .trim()
        .max(255)
        .transform((label) => label || null)
        .nullable()
        .default(null),
    // Omitted on a prestation line: the tarif's price.
    unitPrice: z
        .number()
        .nonnegative('Le prix unitaire doit être positif')
        .multipleOf(0.01, { message: 'Le prix unitaire ne peut pas avoir plus de deux décimales' })
        .optional(),
    quantity: z.number().int().min(1, 'La quantité doit être au moins 1').default(1),
};
// Negative only on a line imputing an avoir: `refineCreditNoteImputation` checks the sign.
export const signedUnitPriceSchema = z
    .number()
    .multipleOf(0.01, { message: 'Le prix unitaire ne peut pas avoir plus de deux décimales' })
    .optional();
export function isFreePurchaseLine(line) {
    return line.prestationId === null;
}
export function refinePurchaseLine(line, ctx) {
    if (line.prestationId !== null) {
        if (line.prestationPriceId === null) {
            ctx.addIssue({ code: 'custom', message: 'Le tarif est requis', path: ['prestationPriceId'] });
        }
        return;
    }
    if (line.prestationPriceId !== null) {
        ctx.addIssue({ code: 'custom', message: 'La prestation est requise', path: ['prestationId'] });
    }
    if (line.label === null) {
        ctx.addIssue({ code: 'custom', message: PURCHASE_LINE_TARGET_ERROR, path: ['label'] });
        return;
    }
    if (line.unitPrice === undefined) {
        ctx.addIssue({
            code: 'custom',
            message: PURCHASE_LINE_PRICE_REQUIRED_ERROR,
            path: ['unitPrice'],
        });
    }
}
export function purchaseLineDisplayName(line) {
    return line.prestation?.name ?? line.label ?? '';
}
